
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/rolr",
      function () {
        return require("private-next-pages/signup/rolr/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/rolr"])
      });
    }
  